export default {
  en: {
    pageTitle: '{orgName} - Trust Centre',
    fallbackPageTitle: 'Trust Centre',
    title: 'Risk Ledger Trust Centre',
    trustedBy: 'As trusted by',
    signUp: 'Get free access to evidence',
    copyright: '© Copyright Risk Ledger Ltd {year}',
    privacy: 'Privacy policy',
    terms: 'Terms and conditions',
    lastModified: 'Last modified {date}',
    assessment: 'Assessment',
    evidence: 'Uploaded evidence',
    documents: 'Documents',
    multipleDomains: 'Multiple domains',
    domainTitle: '{letter}. {name}',
    search: 'Search...',
    answered: 'Answered',
    learnMore: 'Learn more about this control',
    banner: {
      title: 'Free access to full Trust Centre – sign up now',
      description:
        'Connect with {orgName} and start your security review. View supporting evidence at no charge.',
      signUp: 'Sign up',
    },
    labels: {
      sharedUntil: 'Shared with you until',
      shareExpired: 'Share expired',
      shareDeactivated: 'Share deactivated',
      website: 'Website',
      companyNumber: 'Company number',
      country: 'Country',
      alsoKnown: 'Also known as',
      evidence: 'Evidence',
      expiredOn: 'Expired on',
      expiresOn: 'Expires on',
    },
    evidenceFormat: '{n} uploaded files | {n} uploaded file | {n} uploaded files',
    documentsFormat: '{n} documents | {n} document | {n} documents',
    placeholder: {
      signup: 'Create free account',
      or: 'Or, ',
      findOutMore: 'find out more →',
      intercomMessage: 'I would like to learn more about Risk Ledger.',
      retry: 'Retry',
      expired: {
        title: 'Sorry, this link has expired!',
        description:
          'This Trust Centre link has expired. Create an account to connect with {orgName} and thousands of other suppliers already on Risk Ledger.',
      },
      deactivated: {
        title: 'Sorry, this link has been deactivated!',
        description:
          'This Trust Centre link has been deactivated by {orgName}. Create an account to connect with them and thousands of other suppliers already on Risk Ledger.',
      },
      invalid: {
        title: 'Sorry, this link is invalid!',
        description:
          'The link you are trying to access is invalid. Create an account to connect with any supplier.',
      },
      network: {
        title: 'Sorry, there was an error loading the Trust Centre!',
        description: "We couldn't load the Trust Centre. Please try again.",
      },
      noEvidence: {
        title: 'No evidence has been uploaded',
        description:
          '{orgName} has not uploaded any evidence. Create an account to request evidence from them or any of your suppliers.',
      },
    },
    evidenceModal: {
      title: 'Create your free account',
      bullet1: 'Connect with {orgName} and thousands of other suppliers already on Risk Ledger.',
      bullet2: 'View supporting evidence & certifications. Absolutely free.',
      bullet3: 'Start a discussion directly with suppliers on their answers.',
      info: 'Hear from our users: "Signing up was quick, easy, and best of all – free!"',
      yes: 'Create free account',
      no: 'Maybe later',
    },
  },
};
